import React from 'react'

// Block Icons ...
export const minusRadial = (props) => (
	<svg
		{...props}
		width='24'
		height='24'
		fill='#43484D'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 0C5.37282 0 0 5.37282 0 12C0 18.6272 5.37282 24 12 24C18.6272 24 24 18.6272 24 12C24 5.37282 18.6272 0 12 0ZM12 2.24427C17.3877 2.24427 21.7557 6.6123 21.7557 12C21.7557 17.3877 17.3877 21.7557 12 21.7557C6.6123 21.7557 2.24427 17.3877 2.24427 12C2.24427 6.6123 6.6123 2.24427 12 2.24427ZM6.41989 12.2863C6.41989 12.9186 6.93254 13.4313 7.56492 13.4313H16.7252L16.8247 13.428C18.2512 13.3306 18.218 11.1412 16.7252 11.1412H7.56492L7.47947 11.1444C6.88699 11.1881 6.41989 11.6826 6.41989 12.2863Z'
		/>
	</svg>
)
export const plusRadial = (props) => (
	<svg
		{...props}
		width='24'
		height='24'
		fill='#43484D'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 12C0 5.37282 5.37282 0 12 0C18.6272 0 24 5.37282 24 12C24 18.6272 18.6272 24 12 24C5.37282 24 0 18.6272 0 12ZM11 7.41985C11 5.92706 13.1895 5.89388 13.2868 7.32033L13.2899 7.41985L13.29 11.1412H16.7252C18.218 11.1412 18.2512 13.3306 16.8247 13.428L16.7252 13.4313H13.29L13.2901 16.8664C13.2901 17.4701 12.823 17.9646 12.2305 18.0083L12.1451 18.0114C11.5414 18.0114 11.0469 17.5443 11.0032 16.9519L11 16.8664V13.4313H7.56492C6.93254 13.4313 6.41989 12.9186 6.41989 12.2863C6.41989 11.6826 6.88699 11.1881 7.47947 11.1444L7.56492 11.1412H11V7.41985Z'
		/>
	</svg>
)
export const arrowDown = (props) => (
	<svg
		{...props}
		width='16'
		height='10'
		viewBox='0 0 16 10'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path d='M13.8989 0.390524C14.3796 -0.130176 15.1589 -0.130176 15.6395 0.390524C16.1202 0.911223 16.1202 1.75544 15.6395 2.27614L8.87029 9.60948C8.38964 10.1302 7.61036 10.1302 7.12971 9.60948L0.360484 2.27614C-0.120161 1.75544 -0.120161 0.911223 0.360484 0.390524C0.841129 -0.130176 1.62041 -0.130176 2.10105 0.390524L8 6.78105L13.8989 0.390524Z' />
	</svg>
)
export const returnIcon = (props) => (
	<svg
		{...props}
		width='24'
		height='24'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM9.02904 6.62858C9.32643 6.93677 9.32335 7.43192 9.02676 7.73929L8.18105 8.61574H17.688C18.1059 8.61574 18.4444 8.96662 18.4444 9.39946C18.4444 9.83531 18.1058 10.1832 17.688 10.1832H8.18105L9.02676 11.0596C9.32263 11.3662 9.32437 11.8643 9.02904 12.1703C8.73165 12.4785 8.25387 12.4753 7.95727 12.168L5.82058 9.95364C5.67227 9.79993 5.59868 9.59973 5.60002 9.39888C5.5999 9.19831 5.67329 8.99792 5.82286 8.84292L7.95727 6.63094C8.25314 6.32432 8.73371 6.32251 9.02904 6.62858ZM6.35556 15.3995C6.35556 14.9666 6.69111 14.6157 7.11089 14.6157H16.6243L15.7803 13.7393C15.4844 13.4319 15.4813 12.9368 15.7781 12.6286C16.0728 12.3225 16.5524 12.3243 16.8476 12.6309L18.9776 14.8429C19.1269 14.9979 19.2001 15.1983 19.2 15.3989C19.2013 15.5997 19.1279 15.7999 18.9799 15.9536L16.8476 18.168C16.5516 18.4753 16.0748 18.4785 15.7781 18.1703C15.4833 17.8643 15.4851 17.3662 15.7803 17.0596L16.6243 16.1832H7.11089C6.69373 16.1832 6.35556 15.8353 6.35556 15.3995Z'
		/>
	</svg>
)
export const trash = (props) => (
	<svg
		{...props}
		width='20'
		height='24'
		viewBox='0 0 20 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M16.252 24C17.6287 24 18.75 22.8691 18.75 21.4741V5.05263C19.4448 5.05204 20 4.48673 20 3.78947C20 3.08699 19.4399 2.52632 18.7489 2.52632H12.5C12.5 1.13107 11.3807 0 10 0C8.61929 0 7.5 1.13107 7.5 2.52632H1.25109C0.555789 2.52632 0 3.09185 0 3.78947C0 4.49159 0.559543 5.05204 1.25 5.05263V21.4741C1.25 22.8715 2.3684 24 3.74802 24H16.252ZM16.252 21.4737C16.252 21.4737 3.75 21.4754 3.75 21.4741V5.05263H16.2499C16.2498 9.09851 16.2496 21.4737 16.252 21.4737ZM11.25 8.839C11.25 8.14309 11.8048 7.57895 12.5 7.57895C13.1904 7.57895 13.75 8.14271 13.75 8.839V17.6873C13.75 18.3832 13.1952 18.9474 12.5 18.9474C11.8096 18.9474 11.25 18.3836 11.25 17.6873V8.839ZM7.5 7.57895C6.80483 7.57895 6.25 8.14309 6.25 8.839V17.6873C6.25 18.3836 6.80964 18.9474 7.5 18.9474C8.19517 18.9474 8.75 18.3832 8.75 17.6873V8.839C8.75 8.14271 8.19036 7.57895 7.5 7.57895Z'
		/>
	</svg>
)
export const check = (props) => (
	<svg
		{...props}
		width='20'
		height='14'
		viewBox='0 0 20 14'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6.27218 13.4533L0.557892 7.85327C-0.185964 7.12429 -0.185964 5.94238 0.557892 5.2134C1.30175 4.48442 2.50778 4.48442 3.25163 5.2134L7.61905 9.51976L16.7484 0.546734C17.4922 -0.182245 18.6983 -0.182245 19.4421 0.546734C20.186 1.27571 20.186 2.45762 19.4421 3.1866L8.96592 13.4533C8.22206 14.1822 7.01603 14.1822 6.27218 13.4533Z'
		/>
	</svg>
)
export const close = (props) => (
	<svg
		{...props}
		width='14'
		height='14'
		viewBox='0 0 14 14'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7 4.63348L11.1459 0.486827C11.7974 -0.164843 12.8534 -0.161438 13.5067 0.49206C14.1647 1.15011 14.1624 2.20274 13.512 2.85335L9.36608 7L13.512 11.1466C14.1624 11.7973 14.1647 12.8499 13.5067 13.5079C12.8534 14.1614 11.7974 14.1648 11.1459 13.5132L7 9.36652L2.85412 13.5132C2.20257 14.1648 1.14665 14.1614 0.493273 13.5079C-0.164658 12.8499 -0.162445 11.7973 0.488041 11.1466L4.63392 7L0.488041 2.85335C-0.162445 2.20274 -0.164658 1.15011 0.493273 0.49206C1.14665 -0.161438 2.20257 -0.164843 2.85412 0.486827L7 4.63348Z'
		/>
	</svg>
)

export const infoTooltip = (props) => (
	<svg
		{...props}
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM10 8.57143C10.3943 8.57143 10.7143 8.89143 10.7143 9.28571V15C10.7143 15.3943 10.3943 15.7143 10 15.7143C9.60571 15.7143 9.28571 15.3943 9.28571 15V9.28571C9.28571 8.89143 9.60571 8.57143 10 8.57143ZM10.7143 5C10.7143 4.60571 10.3943 4.28571 10 4.28571C9.60571 4.28571 9.28571 4.60571 9.28571 5V6.42857C9.28571 6.82286 9.60571 7.14286 10 7.14286C10.3943 7.14286 10.7143 6.82286 10.7143 6.42857V5Z'
		/>
	</svg>
)

export const checkRadial = (props) => (
	<svg
		{...props}
		width='26'
		height='26'
		viewBox='0 0 26 26'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 13C0 20.1797 5.8203 26 13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13ZM10.3905 17.6095L6.39052 13.6095C5.86983 13.0888 5.86983 12.2446 6.39052 11.7239C6.91122 11.2032 7.75544 11.2032 8.27614 11.7239L11.3333 14.7998L17.7239 8.39052C18.2446 7.86983 19.0888 7.86983 19.6095 8.39052C20.1302 8.91122 20.1302 9.75544 19.6095 10.2761L12.2761 17.6095C11.7554 18.1302 10.9112 18.1302 10.3905 17.6095Z'
			fill='white'
		/>
	</svg>
)

export const noPreview = (props) => (
	<svg
		{...props}
		width='28'
		height='28'
		viewBox='0 0 28 28'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M5 2C3.343 2 2 3.343 2 5V16.586L6.293 12.293C6.683 11.902 7.317 11.902 7.707 12.293L15.5 20.086L20.293 15.293C20.683 14.902 21.317 14.902 21.707 15.293L26 19.586V5C26 3.343 24.657 2 23 2H5ZM28 5C28 2.239 25.761 0 23 0H5C2.239 0 0 2.239 0 5V23C0 25.761 2.239 28 5 28H23C25.761 28 28 25.761 28 23V5ZM26 22.414L21 17.414L16.914 21.5L21.414 26H23C24.657 26 26 24.657 26 23V22.414ZM18.586 26L7 14.414L2 19.414V23C2 24.657 3.343 26 5 26H18.586ZM20 6C18.895 6 18 6.895 18 8C18 9.105 18.895 10 20 10C21.105 10 22 9.105 22 8C22 6.895 21.105 6 20 6ZM16 8C16 5.791 17.791 4 20 4C22.209 4 24 5.791 24 8C24 10.209 22.209 12 20 12C17.791 12 16 10.209 16 8Z'
			fill='#C4C4C4'
		/>
	</svg>
)

export const closePopup = (props) => (
	<svg
		{...props}
		width='12'
		height='12'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0.386985 0.387041C0.901645 -0.129014 1.73698 -0.129014 2.25296 0.387041L8 6.13491L13.747 0.387041C14.263 -0.129014 15.0984 -0.129014 15.613 0.387041C16.129 0.901776 16.129 1.73855 15.613 2.25328L9.86597 8.00115L15.613 13.753C16.129 14.2677 16.129 15.0992 15.613 15.6139C15.0984 16.1287 14.263 16.1287 13.747 15.6139L8 9.8674L2.25296 15.6139C1.73698 16.1287 0.901645 16.1287 0.386985 15.6139C-0.128995 15.0992 -0.128995 14.2677 0.386985 13.753L6.13403 8.00115L0.386985 2.25328C-0.128995 1.73855 -0.128995 0.901776 0.386985 0.387041Z'
			fill='black'
		/>
	</svg>
)
export const LogoReturnado = (props) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='180'
		height='44'
		fill='#009e86'
		viewBox='0 0 180 44'
		{...props}
	>
		<g fillRule='evenodd'>
			<path d='M31.283 14.836c-5.263 0-10.525.003-15.787-.001-1.357 0-2.161-.693-2.231-1.894-.064-1.112.692-1.976 1.918-2.18.19-.032.388-.035.582-.035 10.362 0 20.724-.001 31.086.006 1.576.001 2.49.893 2.383 2.278-.09 1.18-.798 1.827-2.067 1.83-5.295.008-10.59.003-15.884.003v-.007zM38.003 22.33c-4.188 0-8.376.014-12.565-.01-1.234-.008-1.969-.7-2.03-1.762-.08-1.36.697-2.212 2.091-2.218 3.442-.016 6.884-.004 10.325-.005 4.968 0 9.936-.002 14.904 0 1.083 0 1.91.499 2.124 1.358.218.876.088 1.759-.727 2.246-.49.293-1.16.39-1.751.395-4.124.032-8.247.017-12.37.017v-.022zM40.068 25.55c2.664-.001 5.328-.006 7.992.001.909.003 1.626.349 2.068 1.197.377.724.25 1.394-.176 2.018-.51.747-1.293.907-2.14.904-2.567-.012-5.133-.015-7.7-.018-2.664-.003-5.328.017-7.992-.009-1.789-.018-2.81-1.591-2.002-3.045.442-.794 1.187-1.05 2.055-1.05 2.632.004 5.263.002 7.895.001M39.111 36.697c-1.851 0-3.703.006-5.554-.001-1.408-.006-2.335-.82-2.354-2.045-.02-1.217.892-2.067 2.31-2.073 3.767-.016 7.535-.013 11.302.005 1.287.006 2.19.853 2.2 1.98.01 1.278-.862 2.12-2.252 2.13-1.884.015-3.768.004-5.652.004M33.939 43.193c-1.296 0-2.592.002-3.888 0-1.232-.003-2.184-.888-2.163-2.006.02-1.132.954-1.991 2.186-1.989 2.625.006 5.25.016 7.874.036 1.297.01 2.173.823 2.163 1.979-.01 1.142-.911 1.964-2.187 1.975-1.328.01-2.657.002-3.985.002v.003zM35.378 7.23c-5.262 0-10.524.003-15.787 0-1.357-.002-2.161-.693-2.23-1.895-.065-1.112.691-1.976 1.917-2.18.191-.031.388-.035.582-.035 10.362 0 20.724 0 31.086.006 1.576.001 2.49.894 2.383 2.278-.09 1.18-.798 1.828-2.067 1.83-5.295.008-10.59.003-15.884.003v-.006z'></path>
			<path d='M19.387 7.23c-5.263 0-10.525.003-15.787 0-1.357-.002-2.161-.693-2.231-1.895-.064-1.112.692-1.976 1.918-2.18.19-.031.388-.035.582-.035 10.362 0 20.724 0 31.086.006 1.576.001 2.49.894 2.383 2.278-.09 1.18-.798 1.828-2.067 1.83-5.295.008-10.59.003-15.884.003v-.006z'></path>
			<path d='M8.985.794v9.23s.032 1.333-2.145.066C4.662 8.822.437 6.092.437 6.092s-1.138-.845.26-1.69C2.094 3.557 7.49.209 7.49.209s1.397-.748 1.495.585M65.33 23.24c.114-4.842 2.69-7.249 7.702-7.249h.538V19.9h-1.274c-2.096 0-3.143 1.104-3.143 3.284v7.786H65.33v-7.73zM79.017 21.884h5.634c-.226-1.982-1.16-3.001-2.774-3.001s-2.577 1.019-2.86 3m2.86 9.458c-4.53-.142-6.796-2.775-6.796-7.872 0-5.096 2.294-7.644 6.852-7.673 4.757 0 6.994 2.917 6.71 8.778H78.96c.142 2.293 1.133 3.454 2.973 3.454.878 0 1.7-.368 2.435-1.076.34-.368.765-.538 1.274-.538h2.775c-.821 3.171-2.86 4.927-6.54 4.927M94.65 18.666h-.396v8.296c0 .623.368.963 1.105.963h1.16v2.86a20.683 20.683 0 0 1-3.964-.029c-1.415-.141-2.095-1.02-2.067-2.69V11.701h1.954c.991 0 1.812.906 1.812 1.897v2.378h2.265v.821c0 1.076-.82 1.87-1.868 1.87M110.693 24.995c0 2.577-.652 4.276-1.982 5.097-1.331.764-2.803 1.16-4.417 1.16-1.557 0-2.945-.424-4.247-1.274-1.303-.82-1.954-2.463-1.954-4.983v-9.004h3.766v9.769c0 1.67.85 2.491 2.548 2.491 1.699 0 2.548-.821 2.548-2.491v-7.9c-.028-1.246.566-1.869 1.812-1.869h1.926v9.004zM112.33 23.24c.112-4.842 2.689-7.249 7.7-7.249h.539V19.9h-1.274c-2.096 0-3.143 1.104-3.143 3.284v7.786h-3.823v-7.73zM133.12 31.001c-1.247-.085-1.87-.68-1.87-1.869v-7.701c-.085-1.557-.934-2.322-2.604-2.322s-2.52.765-2.549 2.322V31h-3.822v-8.806c0-4.275 2.152-6.399 6.427-6.399 4.275 0 6.37 2.124 6.343 6.4V31h-1.926zM145.487 24.857v-1.388c-.878.368-1.897.68-3.001.906-1.501.283-2.266.991-2.266 2.096.085 1.189.708 1.755 1.898 1.755 2.095 0 3.369-1.246 3.369-3.37m-4.757-4.926h-3.766c.453-2.775 2.407-4.134 5.861-4.134 4.134 0 6.23 1.36 6.314 4.134v5.097c0 4.133-2.491 5.974-6.54 6.257-3.596.283-6.088-1.387-6.088-4.7.085-3.596 2.69-4.559 6.484-4.927 1.614-.198 2.435-.68 2.435-1.5-.085-.85-.878-1.274-2.435-1.274-1.33 0-2.067.34-2.265 1.047M154.627 23.423c-.029 3.03.99 4.558 3.143 4.558 2.151 0 3.227-1.529 3.227-4.558-.085-2.888-1.132-4.304-3.17-4.304-2.04 0-3.087 1.416-3.2 4.304m10.108-9.825V24.47c0 4.502-2.35 6.74-7.022 6.71-4.643-.084-6.965-2.604-6.965-7.587 0-5.097 1.982-7.702 5.974-7.843 1.869 0 3.313.764 4.275 2.322V11.7h1.87c1.018 0 1.868.878 1.868 1.897M170.171 23.583c.029 2.916 1.02 4.388 2.945 4.388 1.925 0 2.888-1.529 2.916-4.502 0-2.916-.962-4.36-2.888-4.36-1.982 0-2.973 1.5-2.973 4.474m9.797 0c0 5.153-2.293 7.758-6.824 7.758-4.53 0-6.795-2.605-6.795-7.758 0-5.21 2.265-7.787 6.795-7.787 4.53 0 6.824 2.577 6.824 7.787'></path>
		</g>
	</svg>
)
export const LogoMerchant = (props) => (
	<svg
		{...props}
		width='48'
		height='48'
		viewBox='0 0 48 48'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<mask
			id='mask0'
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='48'
			height='48'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 0H48V48H0V0Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.0629 26.8123C20.0629 27.3302 19.6431 27.75 19.1252 27.75C18.6073 27.75 18.1875 27.3302 18.1875 26.8123C18.1875 26.2944 18.6073 25.8746 19.1252 25.8746C19.6431 25.8746 20.0629 26.2944 20.0629 26.8123ZM24.3716 26.8123C24.3716 27.3302 23.9518 27.75 23.4339 27.75C22.9161 27.75 22.4963 27.3302 22.4963 26.8123C22.4963 26.2944 22.9161 25.8746 23.4339 25.8746C23.9518 25.8746 24.3716 26.2944 24.3716 26.8123ZM34.125 31.875C34.125 32.3929 33.7054 32.8125 33.1875 32.8125C32.6698 32.8125 32.25 32.3929 32.25 31.875V18.3356C32.25 17.7103 31.9204 17.1617 31.3686 16.8679C30.8166 16.5742 30.1772 16.6074 29.6587 16.9566L26.6387 18.9906C25.0357 20.0702 22.9643 20.07 21.3615 18.9906L18.3412 16.9566C17.8228 16.6074 17.1838 16.5741 16.6314 16.8679C16.0796 17.1617 15.75 17.7103 15.75 18.3356V27.5331C15.75 29.4739 17.1203 30.9375 18.9375 30.9375H24.9375C25.4554 30.9375 25.875 31.3571 25.875 31.875C25.875 32.3929 25.4554 32.8125 24.9375 32.8125H18.9375C16.0986 32.8125 13.875 30.4935 13.875 27.5331V18.3356C13.875 17.025 14.5937 15.8284 15.7507 15.2126C16.9074 14.5969 18.3013 14.6691 19.3886 15.4014L22.4087 17.4354C23.3754 18.0863 24.6246 18.0863 25.5913 17.4352L28.6114 15.4014C29.6983 14.6694 31.0924 14.5967 32.2493 15.2126C33.4063 15.8284 34.125 17.025 34.125 18.3356V31.875ZM24 0C10.7451 0 0 10.7452 0 24C0 37.2547 10.7451 48 24 48C37.2549 48 48 37.2547 48 24C48 10.7452 37.2549 0 24 0Z'
				fill='#FF5894'
			/>
		</g>
	</svg>
)

export const RefundSeparator = (props) => (
	<svg
		{...props}
		width='124'
		height='20'
		viewBox='0 0 124 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<rect y='9' width='40' height='1' fill='#DCDCDC' />
		<rect x='84' y='9' width='40' height='1' fill='#DCDCDC' />
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M72 10C72 15.5228 67.5228 20 62 20C56.4772 20 52 15.5228 52 10C52 4.47715 56.4772 0 62 0C67.5228 0 72 4.47715 72 10ZM59.2115 5.19048C59.4575 5.44731 59.455 5.85994 59.2096 6.11608L58.5101 6.84645H66.3742C66.7199 6.84645 67 7.13885 67 7.49955C67 7.86276 66.7198 8.15265 66.3742 8.15265H58.5101L59.2096 8.88302C59.4544 9.13854 59.4558 9.55356 59.2115 9.80862C58.9655 10.0654 58.5703 10.0628 58.325 9.80665L56.5575 7.96136C56.4348 7.83328 56.3739 7.66644 56.375 7.49907C56.3749 7.33192 56.4356 7.16493 56.5594 7.03577L58.325 5.19245C58.5697 4.93693 58.9672 4.93543 59.2115 5.19048ZM57 12.4995C57 12.1389 57.2776 11.8464 57.6248 11.8464H65.4944L64.7962 11.1161C64.5514 10.8599 64.5489 10.4473 64.7944 10.1905C65.0382 9.93543 65.4349 9.93693 65.6791 10.1925L67.441 12.0358C67.5645 12.1649 67.6251 12.3319 67.625 12.4991C67.6261 12.6664 67.5653 12.8333 67.4429 12.9614L65.6791 14.8066C65.4343 15.0628 65.0399 15.0654 64.7944 14.8086C64.5506 14.5536 64.552 14.1385 64.7962 13.883L65.4944 13.1527H57.6248C57.2797 13.1527 57 12.8628 57 12.4995Z'
			fill='#DCDCDC'
		/>
	</svg>
)

export const shoppingCart = (props) => (
	<svg
		{...props}
		width='20'
		height='20'
		fill='none'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z'
		/>
	</svg>
)

export const trashCart = (props) => (
	<svg
		{...props}
		width='20'
		height='20'
		fill='none'
		viewBox='0 0 24 24'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z'
		/>
	</svg>
)

export const logoutIcon = (props) => (
	<svg
		{...props}
		xmlns='http://www.w3.org/2000/svg'
		height='24'
		viewBox='0 0 24 24'
		width='24'
		fill='#000000'
	>
		<path d='M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z' />
	</svg>
)

export const returnedStatusIcon = (props) => (
	<svg
		{...props}
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM12.0387 8.8381C12.4352 9.24903 12.4311 9.90923 12.0357 10.3191L10.9081 11.4876H23.5839C24.1411 11.4876 24.5926 11.9555 24.5926 12.5326C24.5926 13.1138 24.141 13.5776 23.5839 13.5776H10.9081L12.0357 14.7462C12.4302 15.155 12.4325 15.819 12.0387 16.2271C11.6422 16.6381 11.0052 16.6338 10.6097 16.224L7.76077 13.2715C7.56302 13.0666 7.46491 12.7996 7.46669 12.5318C7.46653 12.2644 7.56439 11.9972 7.76381 11.7906L10.6097 8.84126C11.0042 8.43243 11.6449 8.43002 12.0387 8.8381ZM8.47407 20.5326C8.47407 19.9555 8.92148 19.4876 9.48118 19.4876H22.1657L21.0405 18.3191C20.6458 17.9092 20.6417 17.249 21.0374 16.8381C21.4304 16.43 22.0698 16.4324 22.4635 16.8413L25.3035 19.7906C25.5025 19.9972 25.6001 20.2644 25.6 20.5318C25.6018 20.7996 25.5038 21.0666 25.3065 21.2715L22.4635 24.224C22.0689 24.6338 21.4331 24.6381 21.0374 24.2271C20.6445 23.819 20.6468 23.155 21.0405 22.7462L22.1657 21.5776H9.48118C8.92497 21.5776 8.47407 21.1138 8.47407 20.5326Z'
			fill='#C4C4C4'
		/>
	</svg>
)

export const pendingStatusIcon = (props) => (
	<svg
		{...props}
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='#D3BA2C'
		x='0px'
		y='0px'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12,0.5C5.7,0.5,0.5,5.7,0.5,12S5.7,23.5,12,23.5S23.5,18.3,23.5,12S18.3,0.5,12,0.5z M16.8,16.8l-6-3.7V6.3h1.7v6l5.2,3.1L16.8,16.8z'
		/>
	</svg>
)

export const checkStatusIcon = (props) => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16ZM12.4686 21.9314L7.66863 17.1314C7.04379 16.5065 7.04379 15.4935 7.66863 14.8686C8.29347 14.2438 9.30653 14.2438 9.93137 14.8686L13.6 18.5598L21.2686 10.8686C21.8935 10.2438 22.9065 10.2438 23.5314 10.8686C24.1562 11.4935 24.1562 12.5065 23.5314 13.1314L14.7314 21.9314C14.1065 22.5562 13.0935 22.5562 12.4686 21.9314Z'
			fill='black'
		/>
	</svg>
)
